import { Columns } from "@fullscript/aviary-web";
import type { ReactNode } from "react";

import { Spacer } from "@aviary";
import { Container } from "@aviary/layouts";

interface Props {
  leftContent: ReactNode;
  rightContent: ReactNode;
}

const JourneyCheckoutLayout = ({ leftContent, rightContent }: Props) => {
  return (
    <Container>
      <Spacer type="section" />
      <Columns>
        <Columns.Column columnWidth={6} tabletWidth={12}>
          {leftContent}
        </Columns.Column>
        <Columns.Column columnWidth={1} tabletWidth={12} />
        <Columns.Column columnWidth={5} tabletWidth={12}>
          {rightContent}
        </Columns.Column>
      </Columns>
      <Spacer type="section" />
    </Container>
  );
};

export { JourneyCheckoutLayout };
